module.exports = __webpack_public_path__ + "img/xray.6e891ee3.jpg";